import { fetchAndActivate, getValue } from "firebase/remote-config";
import { type ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useShallow } from "zustand/shallow";
import { remoteConfig } from "@/firebase";
import { useEnableAds } from "@/hooks/useAds";
import { useLocale } from "@/hooks/useUpdateLocation";
import { useFirebaseStore } from "@/stores/useFirebaseStore";
import { CONSTANTS } from "@/constants";

export default function HomeLayout(props: { children: ReactNode }) {
  const enableAds = useEnableAds();
  const { fetchWorldCoinUserLogin } = useLocale();

  useEffect(() => {
    fetchWorldCoinUserLogin();
  }, [fetchWorldCoinUserLogin]);

  useEffect(() => {
    if (!enableAds) {
      return () => {};
    }
    // Google Ads
    const checkDom = window.document.querySelector(
      'script[src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6334078962160959"]'
    );
    if (!checkDom) {
      const script = document.createElement("script");
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6334078962160959";
      script.async = true;

      document.head.appendChild(script);
    }

    setTimeout(() => {
      try {
        (window as any).adsbygoogle = (window as any).adsbygoogle || [];
        (window as any).adsbygoogle.push({
          google_ad_client: "ca-pub-6334078962160959",
        });
      } catch (e) {
        console.error("Adsense error", e);
      }
    }, 100);

    return () => {};
  }, [enableAds]);

  return (
    <div
      className="w-screen h-screen"
      style={{
        backgroundImage: `url("${CONSTANTS.DOMAIN}/images/bg-main.webp")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      {props.children}
      <Outlet />
      <InitRemoteConfigFirebase />
    </div>
  );
}

function InitRemoteConfigFirebase() {
  const setRemoteConfig = useFirebaseStore(
    useShallow((state) => state.setRemoteConfig)
  );

  useEffect(() => {
    fetchAndActivate(remoteConfig)
      .then(() => {
        const eggs_vault_on = getValue(remoteConfig, "eggs_vault_on");
        if (eggs_vault_on.getSource() === "remote")
          setRemoteConfig("eggs_vault_on", eggs_vault_on.asString());

        const eggs_vault_banner_on = getValue(
          remoteConfig,
          "eggs_vault_banner_on"
        );

        if (eggs_vault_banner_on.getSource() === "remote")
          setRemoteConfig(
            "eggs_vault_banner_on",
            eggs_vault_banner_on.asString()
          );
      })
      .catch((err) => {
        // ...
        console.log("Error", err);
      });
  }, [setRemoteConfig]);

  return null;
}
